export { default as hasPermits } from './hasPermits'
